import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { IVisibleViolationsError } from '../types';

export const SET_VISIBLE_VIOLATIONS = 'VISIBLE_VIOLATIONS :: SET';

export type TSetVisibleViolationsAction = IReduxAction<typeof SET_VISIBLE_VIOLATIONS, ISetVisibleViolationsPayload>;

interface ISetVisibleViolationsPayload {
  errors: Array<IVisibleViolationsError>;
  skipHash: string | null;
}

export const setVisibleViolations = actionGenerator<typeof SET_VISIBLE_VIOLATIONS>(SET_VISIBLE_VIOLATIONS);
